const SOFTWARE_URLS = {
	"KW_TRACKER_EXT": "https://chrome.google.com/webstore/detail/amazon-keyword-tracker-re/fgkhimnkbaccbhigaeoggfbmggdidjjj",
	"SCOUT_EXT": "https://chrome.google.com/webstore/detail/amzscout-for-amazon-selle/jjddacdiaghmhplanidommpeehflcphk",
	"SCOUT_EXT_PRO": "https://chrome.google.com/webstore/detail/amazon-product-finder-amz/njopapoodmifmcogpingplfphojnfeea",
	"SCOUT_EXT_NEW": "https://chrome.google.com/webstore/detail/amzscout-for-amazon-selle/jjddacdiaghmhplanidommpeehflcphk",
	"SCOUT_EXT_PRO_NEW": "https://chromewebstore.google.com/detail/amzscout-pro-ai-amazon-pr/cdmbeofnbhgdgnijieodggfmfpamfifg",
	"QUICK_VIEW_EXT": "https://chrome.google.com/webstore/detail/amazon-quick-view-by-amzs/pggamokfileohlopdonjmelbbghhnlah",
	"CALC_EXT": "https://chrome.google.com/webstore/detail/fba-calculator-for-amazon/dkgjopcolgcafhnicdahjemapkniikeh",
	"OA_EXT": "https://chrome.google.com/webstore/detail/amazon-dropshipping-arbit/edkgpjhfpfpgkohafpaliolcfnijnibh",
	"WEB": "https://amzscout.net/app/",
};
const allowedUrls = [`*.${$DOMAIN}`, "*.google.com", "*.youtube.com", "goo.gl"]
const urlParams = new URL(window.location.href).searchParams;
const params = [];
for (let v of urlParams.entries()) {
	if (v[0].startsWith('utm_'))
		params.push(`${v[0]}=${encodeURIComponent(v[1])}`);
}
let utms = '';
params.forEach(p => utms = utms + p + '&');
let url = urlParams.get("url");
url = (SOFTWARE_URLS[url] || url);
let success = Object.values(SOFTWARE_URLS).indexOf(url) > -1;
if (!success) {
	try {
		const domain = new URL(url).origin.split('//')[1];
		success = allowedUrls.some(it => {
			if (it.startsWith("*.")) {
				return domain.endsWith(it.substring(2));
			} else {
				return domain === it;
			}
		});
	} catch (err) {
	}
}
if (success) {
	const goto = url + (utms ? '?' + utms.slice(0, -1) : '');
	const ck = urlParams.get("ck");
	if (ck) {
		const ct = urlParams.get("ct") || 30;
		const date = new Date(Date.now() + ct * 24 * 60 * 60 * 1000);
		const cks = JSON.parse(ck);
		Object.keys(cks).forEach(name => {
			document.cookie = `${name}=${cks[name]}; path=/; expires=` + date.toUTCString();
		});
	}
	window.location.href = goto;
}
